import { gql } from "@apollo/client";

export const EventItemFragment = gql`
  fragment EventItemFragment on academyModel {
    _id
    title
    slug
    place
    topic
    image
    handouts
    segment
    handoutCode
    date
    primaryColor
  }
`;

export const EventsQuery = gql`
  query Events($locale: String, $limit: Int, $filter: JsonType) {
    academyModel(
      locale: $locale
      filter: $filter
      limit: $limit
      sort: { date: 1 }
    ) {
      ...EventItemFragment
    }
  }
  ${EventItemFragment}
`;

export const EventQuery = gql`
  query Event($locale: String, $slug: String!) {
    academyModel(
      locale: $locale
      limit: 1
      filter: { slug: $slug }
      sort: { date: 1 }
    ) {
      ...EventItemFragment
      eventSeriesIcon
      isPresence
      archivalDate
      signupLink
      content
    }
  }
  ${EventItemFragment}
`;
